import { z } from 'zod';

export const CrmCreateManualLeadBody = z.object({
  displayName: z.string().trim().min(1).max(200),
  phone: z.string().trim().max(32).optional(),
  telegramUsername: z.string().trim().max(64).optional(),
  instagramUsername: z.string().trim().max(64).optional(),
  note: z.string().trim().max(4000).optional(),
  cityId: z.uuid().optional(),
});
export type CrmCreateManualLeadBody = z.infer<typeof CrmCreateManualLeadBody>;
